import { push } from 'connected-react-router'

import reserveApi from '../utils/axios'
import { setFlashMessage } from '../actions/flashActions'
import * as AppConstants from '../utils/constants'

export const sessionNew = email => {
  return dispatch =>
    reserveApi({
      method: 'post',
      url: '/login_tokens',
      data: { email }
    })
      .then(() => {
        dispatch(push('/'))
        dispatch(setFlashMessage(AppConstants.SESSION_SUCCESS, 'success'))
      })
      .catch(error => {
        if (error.response.status === 404) {
          dispatch(push('/'))
          dispatch(setFlashMessage(AppConstants.SESSION_FAILURE, 'error'))
        } else {
          dispatch(setFlashMessage(AppConstants.SITE_DOWN, 'error'))
        }
      })
}

export const sessionCreate = (token, redirect = null) => {
  return dispatch =>
    reserveApi({
      method: 'post',
      url: '/sessions',
      data: { token }
    })
      .then(response => {
        dispatch(sessionSuccess(response.data.auth_token))
        dispatch({ type: 'FETCH_USER_FULFILLED', payload: response.data.user })
        dispatch(push(redirect || '/'))
        // dispatch(setFlashMessage("logged in", "success"));
      })
      .catch((error) => {
        if (error.response.status === 401) {
          dispatch(push('/sign-in'))
          dispatch(setFlashMessage(AppConstants.SESSION_BAD_TOKEN, 'error'))
        } else {
          dispatch(setFlashMessage(AppConstants.SITE_DOWN, 'error'))
        }
      })
}

export const sessionCreateNoRedirect = token => {
  return dispatch =>
    reserveApi({
      method: 'post',
      url: '/sessions',
      data: { token }
    })
      .then(response => {
        dispatch(sessionSuccess(response.data.auth_token))
        dispatch({ type: 'FETCH_USER_FULFILLED', payload: response.data.user })
      })
      .catch((error) => {
        if (error.response.status === 401) {
          dispatch(push('/sign-in'))
          dispatch(setFlashMessage(AppConstants.SESSION_BAD_TOKEN, 'error'))
        } else {
          dispatch(setFlashMessage(AppConstants.SITE_DOWN, 'error'))
        }
      })
}

export const sessionDestroy = () => {
  return dispatch => {
    localStorage.removeItem('token')
    dispatch(sessionSuccess(null))
    dispatch(push('/'))
    dispatch(setFlashMessage(AppConstants.SESSION_LOGGED_OUT, 'success'))
  }
}

export const sessionClear = () => {
  return dispatch => {
    localStorage.removeItem("token");
    dispatch(sessionSuccess(null));
    dispatch({ type: "FETCH_USER_FULFILLED", payload: {} });
  };
};

export const sessionSuccess = token => {
  localStorage.setItem('token', token)
  return {
    type: 'SESSION_SUCCESS',
    payload: { token }
  }
}
